// Auto-generated normalizer for table: LeccionEstudiante
export function leccionEstudianteNormalize(row) {
  return {
    idLeccionEstudiante: row.idLeccionEstudiante ?? row.IdLeccionEstudiante ?? row['IdLeccionEstudiante'] ?? 0,
    idLeccion: row.idLeccion ?? row.IdLeccion ?? row['IdLeccion'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    idEstado: row.idEstado ?? row.IdEstado ?? row['IdEstado'] ?? 0,
    monedasGanadas: row.monedasGanadas ?? row.MonedasGanadas ?? row['MonedasGanadas'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
